import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    private darkTheme = new BehaviorSubject<boolean>(this.loadDarkTheme());
    isDarkTheme = this.darkTheme.asObservable();

    loadDarkTheme(): boolean {
        const darkTheme = localStorage.getItem('dark-theme');

        if (darkTheme) {
            const body = document.getElementsByTagName('body')[0];
            body.classList.add('dark-theme');
            return true;
        }
        return false;
    }

    setDarkTheme(isDarkTheme: boolean): void {
        const darkTheme = 'dark-theme';
        const body = document.getElementsByTagName('body')[0];

        if (isDarkTheme) {
            localStorage.setItem(darkTheme, JSON.stringify(isDarkTheme));
            body.classList.add(darkTheme);
        }
        else {
            localStorage.removeItem(darkTheme);
            body.classList.remove(darkTheme);
        }

        this.darkTheme.next(isDarkTheme);
    }
}
